import { UploadFile } from "antd/lib";
import { UploadResponseFile } from "../model/types";

export function extractRef(value: UploadFile<UploadResponseFile>) {
  return value.response !== undefined && "fileId" in value.response
    ? value?.response?.fileId
    : null;
}
